import api from "./api";

export const paymentService = {
  initiatePayment: async (saleId) => {
    const response = await api.post("/payments/initiate", { saleId });
    return response.data;
  },

  getReceipt: async (saleId) => {
    const response = await api.get(`/payments/receipt/${saleId}`);
    return response.data;
  },

  listPayments: async (params = {}) => {
    const response = await api.get("/admin/payments/list", { params });
    return response.data;
  },
};
